import { render, staticRenderFns } from "./ApplicationCommunication.vue?vue&type=template&id=730d3dfa&lang=pug&"
import script from "./ApplicationCommunication.vue?vue&type=script&lang=js&"
export * from "./ApplicationCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports